/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress, Stack } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import React from "react";
import { IProject } from "../../../redux/projects/project.types";
import { initialProject } from "../../../redux/projects/defaultState";
import { IProjectAutoSearchProps } from "./ProjectAutoSearch.types";
import { useBillingCompanyContext } from "../../../providers";
import { api } from "../../../api/api";
import { CustomFormLabel, CustomTextField } from "../../formsComponents";

const INITIAL_STATE: IProject = initialProject;

export const ProjectAutoSearch: React.FC<IProjectAutoSearchProps> = (props) => {
  const {
    label,
    value,
    onSelect,
    disabled,
    error,
    hideAddButton,
    placeholder = "",
  } = props;

  //   const [allProjects, setAllUsers] = React.useState<IUser[]>([]);
  const [allProjects, setAllProjects] = React.useState<IProject[]>([]);
  const [filteredOptions, setFilteredOptions] = React.useState<IProject[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [search, setSearchText] = React.useState<string>("");
  const [openCreateUser, setOpenCreateUser] = React.useState<
    "QUICK" | "FULL" | null
  >(null);
  const { comapny } = useBillingCompanyContext();

  const fetchAllProjects = async () => {
    setLoading(true);
    try {
      let query = `status=ACTIVE&pageNo=1&itemPerPage=1000`; // you can paginate if too large

      if (comapny.customer_uuid) {
        query += `&billing_company_uuid=${comapny.customer_uuid}`;
      }

      const res = await api.get<{ data: IProject[] }>(
        `/project/get-project?${query}`,
      );
      setAllProjects(res.data.data);
      //   setFilteredOptions(res.data.data);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAllProjects();
  }, []);

  React.useEffect(() => {
    if (search.length === 0) {
      setFilteredOptions(allProjects);
    } else {
      const filtered = allProjects.filter((project) =>
        `${project.project_name}`.toLowerCase().includes(search.toLowerCase()),
      );
      console.log("filtered options innner", filtered);
      setFilteredOptions(filtered);
    }
  }, [search, allProjects]);

  //   React.useEffect(() => {
  //     if (value?.project_uuid && allProjects.length > 0) {
  //       const exists = allProjects.find(
  //         (u) => u.project_uuid === value.project_uuid
  //       );
  //       if (!exists) {
  //         const fullName = value.project_name;
  //         setFilteredOptions((prev) => [
  //           ...prev,
  //           {
  //             ...INITIAL_STATE,
  //             project_uuid: value.project_uuid,
  //             project_name: value.project_name,
  //           },
  //         ]);
  //       }
  //     }
  //   }, [value, allProjects]);
  React.useEffect(() => {
    if (value?.project_uuid && allProjects.length > 0) {
      const existsInAll = allProjects.find(
        (p) => p.project_uuid === value.project_uuid,
      );
      const existsInFiltered = filteredOptions.find(
        (p) => p.project_uuid === value.project_uuid,
      );

      if (!existsInAll && !existsInFiltered) {
        setFilteredOptions((prev) => [
          ...prev,
          {
            ...INITIAL_STATE,
            project_uuid: value.project_uuid,
            project_name: value.project_name,
          },
        ]);
      }
    }
  }, [value, allProjects]);

  const getOptionLabel = (option: IProject | string) => {
    if (typeof option === "string") return option;
    return `${option.project_name || ""}`.trim();
  };

  const selectedValue = React.useMemo(() => {
    return (
      allProjects.find(
        (option) => option.project_uuid === value?.project_uuid,
      ) || null
    );
  }, [allProjects, value]);

  console.log("filtered options outer", filteredOptions);

  return (
    <>
      {label && (
        <Box display="flex" justifyContent={"flex-start"} alignItems="center">
          <CustomFormLabel display={"block"}>{label}</CustomFormLabel>
          {/* {!hideAddButton &&
            search.length > 0 &&
            filteredOptions.length === 0 &&
            !loading && (
              <Box
                sx={{
                  paddingLeft: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: 1,
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 1000,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenCreateUser("QUICK");
                }}
              >
                <AddCircleIcon fontSize="small" color="primary" />
                <Typography
                  variant="h6"
                  color="primary"
                  marginLeft={0.5}
                  marginTop={0.3}
                  fontWeight={500}
                >
                  Add User
                </Typography>
              </Box>
            )} */}
        </Box>
      )}

      <Stack direction="row" justifyContent="space-between" spacing={1}>
        <Autocomplete
          id="user-autosearch"
          fullWidth
          disabled={disabled || loading}
          options={filteredOptions}
          value={selectedValue}
          loading={loading}
          filterOptions={(x) => x}
          autoComplete
          includeInputInList
          onFocus={() => {
            if (!allProjects.length) fetchAllProjects();
          }}
          onInputChange={(event, newInputValue, reason) => {
            setSearchText(newInputValue);
            if (reason === "clear") {
              setFilteredOptions(allProjects);
            }
          }}
          onChange={(
            event: React.ChangeEvent<{}>,
            newValue: IProject | null,
          ) => {
            if (newValue) {
              onSelect(newValue);
            } else {
              onSelect(INITIAL_STATE);
            }
          }}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={(option, value) =>
            option.project_uuid === value?.project_uuid
          }
          noOptionsText={
            search.length > 0
              ? `No user found for "${search}"`
              : "No users available"
          }
          renderOption={(props, option) => (
            <li {...props} key={option.project_uuid}>
              {getOptionLabel(option)}
            </li>
          )}
          sx={{
            ".MuiOutlinedInput-root": {
              paddingTop: "2px",
              paddingBottom: "2px",
              fontSize: "0.8rem",
              color: "rgb(38, 38, 38)",
              width: "100%",
              backgroundColor: disabled ? "#f8f9fb" : "inherit",
            },
          }}
          renderInput={(params) => (
            <CustomTextField
              {...params}
              fullWidth
              placeholder={placeholder}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              disabled={disabled}
              error={!!error}
              helperText={error}
            />
          )}
        />
      </Stack>
    </>
  );
};
